import { createIntl } from 'react-intl';
import type { TranslationOwnerType } from '@ast-data/shared';
import { messagesByLocale } from '../../i18n';
import { historyEntity } from '../history/historyEntities';
import { gapFieldLabel } from './translationGapRecords';

/**
 * Always the German catalog, whatever language the interface is in: the
 * context reads like the records it describes, and those are German.
 */
const german = createIntl({ locale: 'de', messages: messagesByLocale.de });

/**
 * What kind of text DeepL is looking at, as a heading over it — "Archäologische
 * Grabungsdokumentation – Planum – Feld: Beschreibung". Sent as `context`, which
 * steers the translation ("Befund" a feature, "Sohle" the base of a pit) and is
 * neither translated nor billed. The record and field names are the ones the
 * forms and the change log use.
 */
export function translationContext(
    ownerType: TranslationOwnerType,
    field: string
): string {
    const parts = [german.formatMessage({ id: 'translation.context.domain' })];
    const spec = historyEntity(ownerType);
    if (spec) {
        parts.push(german.formatMessage({ id: spec.nameId }));
    }
    parts.push(
        german.formatMessage(
            { id: 'translation.context.field' },
            { field: gapFieldLabel(german, ownerType, field) }
        )
    );
    return parts.join(' – ');
}
